export default __webpack_public_path__ + "static/media/18_180219caritas_AM258-min.5cce0f07.jpg";